// src/scripts/contact/internal/ContactSystemManager.js

import { resetState, getInstance } from './state.js';
import { debugHelpers } from './debugHelpers.js';
import { initializeContactSystem } from './init.js';

const isRealBrowser = (() => {
  try {
    return typeof window !== 'undefined' &&
           typeof document !== 'undefined' &&
           typeof navigator !== 'undefined';
  } catch {
    return false;
  }
})();

const isWindowAvailable = () =>
  isRealBrowser && typeof window !== 'undefined';

export default class ContactSystemManager {
  /** bootstrap/init logic */
  static async init() {
    if (isWindowAvailable()) {
      return initializeContactSystem().catch(err => {
        console.warn('⚠️ Auto‑initialization failed', err);
        debugHelpers?.log('Auto‑init failure', { error: err.message });
        throw err;
      });
    } else {
      const msg = isRealBrowser
        ? 'Contact system unavailable: window object not accessible'
        : 'Contact system unavailable in non-browser environment';
      return Promise.reject(new Error(msg));
    }
  }

  /** cleanup logic */
  static async cleanup() {
    try {
      debugHelpers?.log('Starting cleanup process');
      const instance = getInstance?.();
      if (instance?.destroy) {
        await instance.destroy();
      }
      if (isWindowAvailable()) {
        delete window.ContactSystem;
      }
      resetState?.();
      debugHelpers?.log('Cleanup completed successfully');
    } catch (err) {
      console.warn('Error during cleanup:', err);
    }
  }

  /** recovery = cleanup + re‑init */
  static async recover() {
    try {
      debugHelpers?.log('Attempting system recovery');
      await this.cleanup();
      return await this.init();
    } catch (err) {
      debugHelpers?.log('Recovery failed', { error: err.message });
      return null;
    }
  }
}
